import * as React from 'react';
import { css } from '@emotion/core';
import MobileToolbar from '../../layout/mobile/MobileToolbar';
import { Str } from '../../localization/translationKeys';
import { faPlus, faBell, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { Routes } from '../../navigation/routes';
import Msg from '../../localization/Msg';
import { FLEX_COLUMN, FLEX_CENTERED } from '../../layout/flexBox';
import { BTN_HOVER } from '../../forms/styles/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spacer from '../../layout/Spacer';
import { COLORS } from '../../globalStyle/colors';


const ACTION_BTN = css`
  width: 100px;
  height: 100%;
  font-size: 9px;
  text-decoration: none;
  text-align: center;
  overflow-wrap: break-spaces;
  text-transform: uppercase;
  box-sizing: border-box;
  transition: all .2s ease;
`;

const styles = {
  root:           css`
    
  `,
  icon:           css`
    font-size: 22px;
  `,
  devResourceBtn: [
    FLEX_COLUMN,
    FLEX_CENTERED,
    ACTION_BTN,
    BTN_HOVER,
    css`
      color: ${COLORS.DARK_GREY};
    `,
  ],
  addBtn:         [
    FLEX_COLUMN,
    FLEX_CENTERED,
    ACTION_BTN,
    BTN_HOVER,
    css`
      border: none !important;
      background-color: ${COLORS.BLUE};
      color: ${COLORS.WHITE};
    `,
  ],
};


type Props = {
  collaborationEnabled: boolean;
  routes: Routes;
  onClickToAdd: () => void;
  className?: string;
};


/**
 * MobileDevPlanActionBar: a component that renders a bar at the bottom of the screen with Dev Resources and Add Action
 * buttons.
 */
const MobileDevPlanActionBar: React.FC<Props> = props => (
  <MobileToolbar css={styles.root} className={props.className}>
    <Link to={props.routes.DevPlanRemindersModal} css={styles.devResourceBtn}>
      <FontAwesomeIcon icon={faBell} size={'lg'} css={styles.icon} />
      <Spacer sizePx={8} />
      <Msg str={Str.EmailReminders} />
    </Link>
    <Link to={props.routes.EmailDevPlanModal} css={styles.devResourceBtn}>
      <FontAwesomeIcon icon={faEnvelope} size={'lg'} css={styles.icon} />
      <Spacer sizePx={8} />
      <Msg str={props.collaborationEnabled ? Str.SharePlan : Str.EmailPlan} />
    </Link>
    <Link to={props.routes.AddPlanItem} css={styles.addBtn}>
      <FontAwesomeIcon icon={faPlus} size={'lg'} css={styles.icon} />
      <Spacer sizePx={8} />
      <Msg str={Str.AddItem} />
    </Link>
  </MobileToolbar>
);

export default MobileDevPlanActionBar;
